<template>
<form id="physicians-search-form" class="vue-app">
    <div class="container">
        <div class="form-row">
            <div class="col-12 col-md-6">
                <strong class="h5">Search By:</strong>
                <div class="form-group mt-2">
                    <input id="name" type="text" class="form-control"
                    placeholder="Search by name" v-model="form.name" ref="name">
                </div>
                <div class="form-group">
                    <multiselect
                        id="search-speciality"
                        ref="search_speciality"
                        v-model="form.specialty"
                        :options="specialties"
                        :multiple="true"
                        placeholder="Specialty:"
                        :close-on-select="false"
                        :clear-on-select="true"
                        selectLabel="Press enter or click to select"
                        deselectLabel="Press enter or click to remove"
                        label="text"
                        track-by="id"
                        :maxHeight="dropdownHeight"
                        @open="onMultiselectOpen"
                        @close="onMultiselectClose"
                    >
                    </multiselect>
                </div>
                <div class="form-group">
                    <multiselect
                        id="search-language"
                        ref="search_language"
                        v-model="form.language"
                        :options="languages"
                        :multiple="true"
                        placeholder="Language Spoken:"
                        :close-on-select="false"
                        :clear-on-select="true"
                        selectLabel="Press enter or click to select"
                        deselectLabel="Press enter or click to remove"
                        label="text"
                        track-by="id"
                        :maxHeight="dropdownHeight"
                        @open="onMultiselectOpen"
                        @close="onMultiselectClose"
                    >
                    </multiselect>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <strong class="h5">Physicians Near Me:</strong>
                <div class="form-row mt-2">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <multiselect
                                id="search-county"
                                ref="search_county"
                                v-model="form.county"
                                :options="counties"
                                :multiple="true"
                                placeholder="County:"
                                :close-on-select="false"
                                :clear-on-select="true"
                                selectLabel="Press enter or click to select"
                                deselectLabel="Press enter or click to remove"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <multiselect
                                id="search-radius"
                                ref="search_radius"
                                v-model="form.radius"
                                :options="radii"
                                :close-on-select="true"
                                :search="false"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            ></multiselect>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <input id="postal_code" type="text" class="form-control"
                                placeholder="City or ZIP Code" v-model="form.postal_code" ref="postal_code" :disabled="form.using_geolocation">
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="form-group">
                            <button type="button" @click.prevent="getUserLocation()"
                            class="btn btn-primary location-btn w-100"
                            v-bind:class="{'using-geolocation': form.using_geolocation}">Detect My Location</button>
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 sub-text pt-2">
                        You can also <a href="/location">Find a Location</a> or <a href="/clinical-trials">Find a Clinical Trial</a>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form-row">
                    <button type="submit" @click.prevent="searchPhysicians(true)" class="btn btn-primary mr-1">Search</button>
                    <button type="button" @click.prevent="resetForm()" class="btn btn-dark">Reset Form</button>
                </div>
            </div>
        </div>
    </div>
</form>
</template>

<script>
import ApiCalls from "../../api/apiServices";
import { Loader } from '@googlemaps/js-api-loader';
import { mapMutations } from 'vuex'
const METERS_PER_MILE = 1609.34;
const MULTISELECT_DELIMITER = ',';
const MUTLISELECT_FIELDS = ['specialties', 'languages', 'counties'];
const result_items = document.querySelectorAll('.physician-search-result');
let geocoder;
document.addEventListener('DOMContentLoaded', () => {
    const loader = new Loader({
        apiKey: window.gmapi,
        version: 'weekly',
        libraries: ['geometry']
    });
    loader.load().then(() => {
        geocoder = new google.maps.Geocoder();
        return geocoder;
    }).then((geocoder) => {
        document.dispatchEvent(new Event('WFMapReady'));
    });
});
export default {
    data() {
        let form = {};
        let radii = this.getRadiusOptions();
        MUTLISELECT_FIELDS.forEach((key) => {
            form[key] = [];
        });
        form.radius = radii[1];
        form.using_geolocation = false;

        return {
            form: form,
            specialties: [],
            languages: [],
            counties: [],
            radii: radii,
            dropdownHeight: 200,
        }
    },
    methods: {
        ...mapMutations(
            ['resetPhysiciansCount', 'showMorePhysicians']
        ),
        getRadiusOptions() {
            return [
                { id: 10, text: "Within 10 miles"},
                { id: 20, text: "Within 20 miles"},
                { id: 50, text: "Within 50 miles"},
                { id: 100, text: "Within 100 miles"},
            ];
            
        },
        getUserLocation() {
            this.form.using_geolocation = !this.form.using_geolocation;
            if (!this.form.using_geolocation) {
                this.form.lat = null;
                this.form.long = null;
            } else {
                if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    this.form.lat = position.coords.latitude;
                    this.form.long = position.coords.longitude;
                });
                this.form.postal_code = null;
                } else {
                this.form.using_geolocation = false;
                }
            }
        },
        retrieveDropdowns(){
            Promise.all([
                this.getDropdownValues(window.specialties).then((results) => {
                    Object.values(results).forEach((result) => {
                        let text = result.text;
                        let slug = result.slug;
                        let specialty = {
                        text: text,
                        value: slug,
                        id: slug,
                        disabled: false
                        };
                        this.specialties.push(specialty);
                    });
                }),
                this.getDropdownValues(window.languages).then((results) => {
                    Object.values(results).forEach((result) => {
                        let text = result.text;
                        let slug = result.slug;
                        let language = {
                        text: text,
                        value: slug,
                        id: slug,
                        disabled: false
                        };
                        this.languages.push(language);
                    });
                }),
                this.getDropdownValues(window.counties).then((results) => {
                    Object.values(results).forEach((result) => {
                        let text = result.text;
                        let slug = result.slug;
                        let type = {
                        text: text,
                        value: slug,
                        id: slug,
                        disabled: false
                        };
                        this.counties.push(type);
                    });
                })
            ]).then(() => {
                this.searchPhysicians();
            })
        },
        getDropdownValues(type){
            return new Promise((resolve, reject) => {
                resolve(type)
            })
        },
        getMultiSelectValues(field){
            if(field) {
                return field.map((a) => a.value)
            } else {
                return []
            }
        },
        findReferenceLocation() {
            return new Promise((resolve, reject) => {
                if (this.form.lat) {
                resolve(new google.maps.LatLng({
                    lat: this.form.lat,
                    lng: this.form.long
                }))
                } else if (this.form.postal_code) {
                geocoder.geocode({ address: this.form.postal_code }, (results, status) => {
                    if (status == 'OK') {
                    resolve(results[0].geometry.location);
                    } else {
                    reject("Geocoder status: " + status);
                    }
                })
                } else {
                resolve(0);
                }
            });
        },
        findCommonElements(arr1, arr2){
            return arr1.some(item => arr2.includes(item))
        },
        searchPhysicians(scroll = false){
            this.resetPhysiciansCount(this)
            result_items.forEach((elem) => {
                elem.classList.remove('active', 'valid');
            })
            this.findReferenceLocation().then((refLoc) => {
                [...result_items].filter((a) => {
                    let accept = true;
                    if(refLoc){
                        let coords = a.getAttribute('data-coords')
                        let coord_arr = coords.split(';')
                        let radius = this.form.radius.id
                        let anyCoordPass = false;
                        if(coord_arr.length > 1) {
                            coord_arr.forEach(function(coord){
                                let lat_long_arr = coord.split(',')
                                if( lat_long_arr.length > 1){
                                let dist = google.maps.geometry.spherical.computeDistanceBetween(refLoc, new google.maps.LatLng({
                                    lat: parseFloat(lat_long_arr[0]),
                                    lng: parseFloat(lat_long_arr[1])
                                }));
                                if ( dist < radius * METERS_PER_MILE ) anyCoordPass = true;
                                }
                            })
                            accept = anyCoordPass;
                        } else {
                            accept = false
                        }
                    }
                    let formCounties = this.getMultiSelectValues(this.form.county)
                    let physCounties = a.getAttribute('data-counties').split(';')
                    if (formCounties.length && !this.findCommonElements(formCounties, physCounties)){
                        accept = false;
                    }
                    let formLanguages = this.getMultiSelectValues(this.form.language)
                    let physLanguages = a.getAttribute('data-lang').split(';')
                    if (formLanguages.length && !this.findCommonElements(formLanguages, physLanguages)) {
                        accept = false;
                    }
                    let physName = this.form.name
                    if(physName) {
                        let terms = physName.split(' ');
                        terms.forEach((t) => {
                            if (a.getAttribute('data-name').toLowerCase().indexOf(t.toLowerCase()) < 0) accept = false
                        })
                    }
                    let formSpecs = this.getMultiSelectValues(this.form.specialty)
                    let physSpecs = a.getAttribute('data-specialties').replace(/&amp; /g, '').replace(/ /g, '-');
                    physSpecs = physSpecs.split(';')
                    
                    if (formSpecs.length && !this.findCommonElements(formSpecs, physSpecs)) {
                        accept = false;
                    }
                    if(accept){
                        a.classList.add('valid')
                    }
                    return accept
                })
                this.showResults()
                if (scroll) document.querySelector('.vue-search-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, () => {
                // geocoding error
            })
        },
        showResults(){
            let count = 0
            let allValid = 0
            result_items.forEach((elem) => {
                if(count < this.$store.state.physicians_shown_count) {
                    if(elem.classList.contains('valid')) { 
                        elem.classList.add('active')
                        count++
                        allValid++
                    }
                } else {
                    if (elem.classList.contains('valid')) {
                        allValid++
                    }
                }
            })
            if (count) {
                document.querySelector(".no-results").classList.add("d-none");
            } else {
                document.querySelector(".no-results").classList.remove("d-none");
            }

            if (count == allValid) {
                document.querySelector("#showMore").classList.add("d-none");
            } else {
                document.querySelector("#showMore").classList.remove("d-none");
            }
        },
        showMore(){
            // add the shown count to itself, then run showResults again
            this.showMorePhysicians(this)
            this.showResults()
        },
        setClickEvents(){
            let self = this
            document.addEventListener('click', function (e) {
                if(e.target.id == "showMore"){
                    self.showMore()
                }
            })
        },
        resetForm() {
            let form = {};
            for (let key in this.form) {
                form[key] = null;
            }
            // set default arrays for mutli-selects
            MUTLISELECT_FIELDS.forEach((key) => {
                form[key] = [];
            });
            form.radius = this.radii[1];
            form.using_geolocation = false;
            this.form = form;
        },

        findSpacingTarget() {
            return this.$el.closest(".form-container")
        },
        findPositionTop(elem) {
            let offsetTop = 0;
            do {
                offsetTop += elem.offsetTop
            } while (elem = elem.offsetParent)
            return offsetTop;
        },

        onMultiselectOpen(id) {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                let dropdownField = this.$el.querySelector("#" + id).closest('.multiselect')
                let ddtop = this.findPositionTop(dropdownField) - this.findPositionTop(spacingTarget)
                spacingTarget.style.marginBottom = Math.max(0, (ddtop + dropdownField.offsetHeight + this.dropdownHeight) - spacingTarget.offsetHeight) + "px"
            }
        },

        onMultiselectClose() {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                spacingTarget.style.marginBottom = 0
            }
        },
    },
    created(){
        this.retrieveDropdowns()
        this.setClickEvents()
    },
    mounted() {
        ["search_county", "search_radius", "search_speciality", "search_language"].forEach((item) => {
            this.$refs[item].$refs.search.setAttribute("autocomplete", "off");
        })
    }
}
</script>